/**
 * StoretextUnavailableFallback
 *
 * Renders a concise fallback message when Store Text analysis is unavailable
 * for the current audit. Used by renderers upstream of StoretextAnalysisView
 * so that missing / partial storetext payloads do not crash the page.
 *
 * This component intentionally reads no audit payload fields. It takes no
 * required props; callers may pass `className` to customize the wrapper.
 */

import type { FC } from "react";

export interface StoretextUnavailableFallbackProps {
  /** Optional wrapper class override. */
  className?: string;
}

export const StoretextUnavailableFallback: FC<StoretextUnavailableFallbackProps> = ({ className }) => {
  const wrapperClass = className ?? "p-6 text-center text-zinc-500 dark:text-zinc-400";
  return (
    <div className={wrapperClass}>
      Store Text analysis is unavailable for this audit.
    </div>
  );
};
